import { BTC, ETH } from "../ui-kit/assets";


export const crypto_icons = {
    'BTC': BTC,
    'ETH': ETH
}
